import * as urlUtils from 'utils/Url';


export function getPathRecommenderOverview(qs={}) {
  return urlUtils.appendQueryString(`/recommender-overview`, qs);
}

export function getPathRecommenderConnections(qs={}) {
  return urlUtils.appendQueryString(`/recommender-connections`, qs);
}

// App-level analytics dashboard (distinct from per-recommender getPathRecommenderAnalytics).
export function getPathRecommenderAnalyticsDashboard(qs={}) {
  return urlUtils.appendQueryString(`/recommender-analytics`, qs);
}

export function getPathAddRecommender() {
  return `/recommenders/add`;
}

export function getPathEditRecommender(recommenderId) {
  return `/recommenders/${recommenderId}/edit`;
}

export function getPathRecommenders(qs={}) {
  return urlUtils.appendQueryString(`/recommenders`, qs);
}

export function getPathRecommenderOutput(recommenderId, qs={}) {
  return urlUtils.appendQueryString(`/recommenders/${recommenderId}/output`, qs);
}

export function getPathRecommenderSettings() {
  return `/recommender-settings`;
}

export function getPathEditRecommenderSettings() {
  return `/recommender-settings/edit`;
}

export function getPathRecommenderAnalytics(recommenderId, qs={}) {
  return urlUtils.appendQueryString(`/recommenders/${recommenderId}/analytics`, qs);
}

export function getPathRecommenderConversions(recommenderId, qs={}) {
  return urlUtils.appendQueryString(`/recommenders/${recommenderId}/conversions`, qs);
}

